module.exports = __webpack_public_path__ + "static/media/slideshow-27.fb30dd2d.jpeg";